const features = [
  { id: 1, icon: 'ri-flashlight-line', title: '秒开播放', desc: '加载速度行业领先，点击即播无需等待，彻底告别缓冲转圈' },
  { id: 2, icon: 'ri-forbid-2-line', title: '零广告纯净', desc: '全程无任何形式广告植入，给你最纯粹沉浸的观影体验' },
  { id: 3, icon: 'ri-hd-line', title: '高清画质', desc: '支持全高清流畅播放，自适应码率确保不同网络下的最佳画质' },
  { id: 4, icon: 'ri-device-line', title: '全设备支持', desc: '电脑、平板、手机无缝切换，随时随地打开即看，追剧不间断' },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 text-center mb-2">平台优势</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为什么选择爱丫爱丫影院</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((f) => (
            <div key={f.id} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 text-center">
              <span className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${f.icon} text-primary-600 text-xl`}></i>
              </span>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}